export const safeGlobal = global;
